import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  },
  submitted: 0,
  // fmsNav: 0,
};

const secfilterSlice = createSlice({
  name: "secfilter",
  initialState,
  reducers: {
    addFilters(state, action) {
      state.data = action.payload.data;
      state.submitted = action.payload.submitted;
      // state.fmsNav = action.payload.fmsNav;
    },
    applyFilters(state, action) {
      state.data = action.payload;
    },
    chgSubmitted(state, action) {
      state.submitted = action.payload;
    },
    // chgFmsNav(state, action) {
    //   state.fmsNav = action.payload;
    // },
    resetFilters(state) {
      state.data = initialState.data;
      state.submitted = initialState.submitted;
    },
  },
});

export const {
  addFilters,
  applyFilters,
  chgSubmitted,
  // chgFmsNav,
  resetFilters,
} = secfilterSlice.actions;

export default secfilterSlice.reducer;
